// All arguments are Iris
// TODO consider rephrasing label to type, to allow for future DTDL labels on relationships.

class Edge {
  constructor(source, target, label) {
    this.source = source
    this.target = target
    this.label = label
  }
}

export { Edge }
